import { IsBoolean, IsDate, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { SupplierDeliveryDto } from './supplierDelivery.dto';

export class SupplierDto extends BaseDto {

  @IsString()
  name: string;

  @IsString()
  @IsOptional()
  address: string;

  @IsString()
  @IsOptional()
  phone: string;

  @IsString()
  @IsOptional()
  contactName: string;

  @IsString()
  @IsOptional()
  contactEmail: string;

  @IsString()
  @IsOptional()
  contactPhone: string;

  @IsString()
  @IsOptional()
  orderContact: string;

  @IsString()
  @IsOptional()
  orderEmail: string;

  @IsDate()
  startDate: Date;

  @IsDate()
  @IsOptional()
  endDate: Date;

  @IsString()
  @IsOptional()
  reference: string;

  @IsString()
  @IsOptional()
  companyNumber: string;

  @IsString()
  @IsOptional()
  iban: string;
  
  @IsString()
  @IsOptional()
  swiftBic: string;

  @IsString()
  @IsOptional()
  accountName: string;

  @IsString()
  @IsOptional()
  vatNumber: string;

  @IsBoolean()
  @IsOptional()
  cashOnDelivery: boolean;

  @IsBoolean()
  @IsOptional()
  creditTerms: boolean;

  @IsNumber()
  @IsOptional()
  creditTermsDays: number;

  @IsNumber()
  @IsOptional()
  creditAmount?: number;

  @IsString()
  @IsOptional()
  accountsReference: string;

  @IsBoolean()
  @IsOptional()
  isActive: boolean;

  @IsNumber()
  @IsOptional()
  minDeliveryValue: number;

  @IsNumber()
  @IsOptional()
  minDeliveryAmount: number;

  @IsNumber()
  @IsOptional()
  deliveryCost: number;

  @IsBoolean()
  @IsOptional()
  isEmergencyDelivery: boolean;

  @IsNumber()
  @IsOptional()
  costPerDelivery?: number;

  @IsNumber()
  @IsOptional()
  costPerBelowMinDeliveryValue?: number;

  @IsNumber()
  @IsOptional()
  costPerBelowMinDeliveryVolume?: number;

  @IsNumber()
  @IsOptional()
  vatRateId?: number;

  @IsString()
  @IsOptional()
  merchantAccountName: string;

  @IsNumber()
  @IsOptional()
  noActiveStocks?: number;

  @IsString()
  @IsOptional()
  photoURL: string;

  // Dtos for relations 
  merchant: MerchantDto;
  merchantGroup: MerchantGroupDto;
  supplierDelivery?: SupplierDeliveryDto[];

}
